import { GalleryGrid } from '@/components/gallery/GalleryGrid';
import { SEOHead } from '@/components/layout/SEOHead';
import { FadeIn } from '@/components/motion/FadeIn';
import { getAllProjects } from '@/lib/content';

export function ProjectsPage() {
  const projects = getAllProjects();

  return (
    <>
      <SEOHead
        title="Projects · Brian Ellison Design"
        description="Selected projects by Brian Ellison Design — residential, commercial, and hospitality interiors across Florida."
        canonical="https://brianellisondesign.com/projects"
      />
      <section className="page-hero">
        <div className="container">
          <FadeIn>
            <p className="eyebrow">Portfolio</p>
            <h1 className="page-hero__title">Selected work.</h1>
            <p className="subtitle">
              A small, considered collection. Each project is shaped by its place, its
              materials, and the people who will live with it.
            </p>
          </FadeIn>
        </div>
      </section>
      <section className="container section">
        <GalleryGrid projects={projects} />
      </section>
    </>
  );
}
